var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHideIcon = function SvgHideIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "hide-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.135,
    height: 19.898
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108467",
    d: "M18.908 9.95a2.843 2.843 0 1 1-2.842-2.843 2.843 2.843 0 0 1 2.843 2.843"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108468",
    d: "M31.371 9.035C31.061 8.667 23.707 0 16.071 0S1.078 8.667.771 9.035l-.765.914.765.914c.31.368 7.664 9.035 15.3 9.035s14.993-8.667 15.3-9.035l.765-.914Zm-15.3 6.6a5.685 5.685 0 1 1 5.685-5.685 5.691 5.691 0 0 1-5.688 5.684Z"
  })));
};
export default SvgHideIcon;